import React, { FC, useEffect } from 'react';
import { Badge, Grid, Menu } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as NotificationIcon } from 'assets/newNotification.icon.svg';
import { ReactComponent as MessageIcon } from '../../../assets/message.icon.svg';

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { NotificationsSelector } from '../../../store/notifications/selectors';
import { INotification } from '../../../store/notifications/types';
import { removeNotification, setNotifications } from '../../../store/notifications';
import { decodeAccessToken } from '../../../utils/getDecodedAccessToken';
import { LOCAL_STORAGE_TOKEN, getStorageNotifications } from '../../../constants/storage';

import useStyles from '../styles';
import { tt } from '@i18n/tt';

const Notifications: FC = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const dispatch = useAppDispatch();
  const notifications = useAppSelector(NotificationsSelector);
  const navigate = useNavigate();

  useEffect(() => {
    const loadNotifications = async () => {
      try {
        const token = localStorage.getItem(LOCAL_STORAGE_TOKEN);
        if (token) {
          const decoded = decodeAccessToken(token);
          const notifications = await getStorageNotifications(decoded.contactId);

          dispatch(setNotifications(notifications));
        }
      } catch {
        // If token decode fails, skip loading notifications
      }
    };

    loadNotifications();
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleNotificationClick = (notification: INotification): void => {
    if (notification.chatId) {
      dispatch(removeNotification(notification.chatId));
    }
    if (notification.link) {
      navigate(notification.link);
      setAnchorEl(null);
    }
  };

  return (
    <div>
      <Badge badgeContent={notifications.length} color="success" onClick={handleClick}>
        <NotificationIcon />
      </Badge>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} className="notificationMenu">
        <Grid sx={{ minWidth: '350px', minHeight: '250px', maxHeight: '400px' }}>
          <div className={classes.notificationsList}>
            {notifications.map(notification => (
              <div
                className={classes.notificationItem}
                key={notification.id}
                role="presentation"
                onClick={() => {
                  handleNotificationClick(notification);
                }}
              >
                <MessageIcon />
                {notification.text}
              </div>
            ))}
          </div>

          {notifications.length === 0 && (
            <div className={classes.notificationMenuText}>{tt('common.noNewNotifications')}</div>
          )}
        </Grid>
      </Menu>
    </div>
  );
};

export default Notifications;
